export default "__VITE_ASSET__8DXefQYY__"